import { render } from "./StaffSuccessPage.vue?vue&type=template&id=685f0268"
import script from "./StaffSuccessPage.vue?vue&type=script&lang=js"
export * from "./StaffSuccessPage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__